"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I18n = require("i18n-js");
var refund_request_1 = require("./refund_request");
var url_helpers_1 = require("../components/shared/url_helpers");
var strongOpen = '<strong>';
var strongClose = '</strong>';
var payoutsLinkOpen = "<a href=\"" + url_helpers_1.default.dashboardSellingPayoutsPath + "\" target=\"_blank\">";
var linkClose = '</a>';
function getRefundExplanationLineItems(userType, refundType, order, refundState, refundRequest, refundAmount, refundReason) {
    if (userType === refund_request_1.IUserType.BUYER) {
        return buyerExplanationItems(refundReason);
    }
    if (refundRequest.isPersisted) {
        return sellerUpdateRefundRequestLineItems(order, refundState, refundAmount);
    }
    if (refundState === refund_request_1.IRefundState.CONDITIONALLY_APPROVED) {
        return sellerConditionallyApprovedRefundItems();
    }
    if (refundType === refund_request_1.IRefundType.FULL) {
        return sellerApprovedFullRefundItems(order);
    }
    return sellerApprovedPartialRefundItems(order);
}
exports.getRefundExplanationLineItems = getRefundExplanationLineItems;
function buyerExplanationItems(refundReason) {
    var items = [];
    if (refundReason) {
        items.push(I18n.t("discovery.dashboard.refundRequests.buyer.explanation.reasons." + refundReason));
    }
    items.push(I18n.t('discovery.dashboard.refundRequests.buyer.explanation.response'));
    return items;
}
exports.buyerExplanationItems = buyerExplanationItems;
function sellerUpdateRefundRequestLineItems(order, refundState, refundAmount) {
    var items = [];
    if (refundState === refund_request_1.IRefundState.CONDITIONALLY_APPROVED) {
        items = sellerConditionallyApprovedRefundItems();
    }
    if (order.isPaypal && refundState === refund_request_1.IRefundState.APPROVED) {
        items.push(I18n.t('discovery.dashboard.refundRequests.seller.explanation.paypal'));
    }
    if (refundState === refund_request_1.IRefundState.APPROVED) {
        items.push(I18n.t('discovery.dashboard.refundRequests.seller.explanation.update.refundAmount'));
    }
    if (order.sellingFeeAmount && refund_request_1.isFullRefund(order, refundAmount)) {
        var sellingFeeKey = order.sellingFeesDeductedFromPayouts ? 'fullRefundToPayout' : 'fullRefund';
        items.push(I18n.t("discovery.dashboard.refundRequests.seller.explanation.update." + sellingFeeKey, {
            strongOpen: strongOpen,
            strongClose: strongClose,
            amount: order.sellingFeeAmount.display,
        }));
    }
    if (order.sellingFeeAmount && !refund_request_1.isFullRefund(order, refundAmount)) {
        items.push(I18n.t('discovery.dashboard.refundRequests.seller.explanation.update.partialRefund'));
    }
    return items;
}
exports.sellerUpdateRefundRequestLineItems = sellerUpdateRefundRequestLineItems;
function sellerConditionallyApprovedRefundItems() {
    return [
        I18n.t('discovery.dashboard.refundRequests.seller.explanation.conditionallyApproved.refundComplete'),
        I18n.t('discovery.dashboard.refundRequests.seller.explanation.conditionallyApproved.refundAdjustment'),
    ];
}
exports.sellerConditionallyApprovedRefundItems = sellerConditionallyApprovedRefundItems;
function sellerApprovedPartialRefundItems(order) {
    var items = [
        I18n.t('discovery.dashboard.refundRequests.seller.explanation.partialRefund.amount'),
    ];
    var hasPayout = order.payoutAmountAvailableToRefund;
    if (hasPayout) {
        items.push(I18n.t('discovery.dashboard.refundRequests.seller.explanation.partialRefund.payout', {
            linkClose: linkClose,
            linkOpen: payoutsLinkOpen,
            amount: order.payoutAmountAvailableToRefund.display,
        }));
    }
    if (order.sellingFeeAmount) {
        var sellingFeeKey = order.sellingFeesDeductedFromPayouts ? 'sellingFees' : 'sellingFeesCreditedToPayout';
        items.push(I18n.t("discovery.dashboard.refundRequests.seller.explanation.partialRefund." + sellingFeeKey, {
            strongOpen: strongOpen,
            strongClose: strongClose,
            amount: order.sellingFeeAmount.display,
        }));
    }
    return items;
}
exports.sellerApprovedPartialRefundItems = sellerApprovedPartialRefundItems;
function sellerApprovedFullRefundItems(order) {
    var items = [
        I18n.t('discovery.dashboard.refundRequests.seller.explanation.fullRefund.refundAmount', {
            strongOpen: strongOpen,
            strongClose: strongClose,
            amount: order.amountAvailableToRefund.display,
        }),
    ];
    if (order.reverbRemittedTaxAmountAvailableToRefund.amountCents !== 0) {
        items.push(I18n.t('discovery.dashboard.refundRequests.seller.explanation.fullRefund.taxRemittedByReverb', {
            strongOpen: strongOpen,
            strongClose: strongClose,
            amount: order.reverbRemittedTaxAmountAvailableToRefund.display,
        }));
    }
    if (order.sellingFeeAmount) {
        var sellingFeeKey = order.sellingFeesDeductedFromPayouts ? 'sellingFees' : 'sellingFeesCreditedToPayout';
        items.push(I18n.t("discovery.dashboard.refundRequests.seller.explanation.fullRefund." + sellingFeeKey, {
            strongOpen: strongOpen,
            strongClose: strongClose,
            amount: order.sellingFeeAmount.display,
        }));
    }
    if (order.isPaypal) {
        items.push(I18n.t('discovery.dashboard.refundRequests.seller.explanation.paypal'));
    }
    var hasCompletedPayout = order.payoutAmountAvailableToRefund && order.hasCompletedPayout;
    if (hasCompletedPayout) {
        items.push(I18n.t('discovery.dashboard.refundRequests.seller.explanation.fullRefund.completedPayout.original', {
            strongOpen: strongOpen,
            strongClose: strongClose,
            amount: order.payoutAmountAvailableToRefund.display,
        }));
        items.push(I18n.t('discovery.dashboard.refundRequests.seller.explanation.fullRefund.completedPayout.refund', {
            strongOpen: strongOpen,
            strongClose: strongClose,
            linkClose: linkClose,
            amount: order.payoutAmountAvailableToRefund.display,
            linkOpen: payoutsLinkOpen,
        }));
    }
    var hasPendingPayout = order.payoutAmountAvailableToRefund && !order.hasCompletedPayout;
    if (hasPendingPayout) {
        items.push(I18n.t('discovery.dashboard.refundRequests.seller.explanation.fullRefund.pendingPayout.original', {
            strongOpen: strongOpen,
            strongClose: strongClose,
            amount: order.payoutAmountAvailableToRefund.display,
        }));
        items.push(I18n.t('discovery.dashboard.refundRequests.seller.explanation.fullRefund.pendingPayout.refund', {
            strongOpen: strongOpen,
            strongClose: strongClose,
            linkClose: linkClose,
            amount: order.payoutAmountAvailableToRefund.display,
            linkOpen: payoutsLinkOpen,
        }));
    }
    return items;
}
exports.sellerApprovedFullRefundItems = sellerApprovedFullRefundItems;
//# sourceMappingURL=refund_explanation_line_items.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/refund_requests/refund_explanation_line_items.js
// module id = rE3E
// module chunks = 20 21